// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-production/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springProductionEN: PageEntry = {
  id: "post.federherstellung",
  locale: "en",
  slug: "spring-production",
  seo: {
    title: "Glossary: Spring production explained simply | Dietz GmbH",
    description: "Spring production is the process of manufacturing springs in which raw materials are moulded into the desired spring shape using various methods. This process can include various t",
  },
  type: "post",
  h1: "Glossary: Spring production explained simply",
  intro: "Spring production is the process of manufacturing springs in which raw materials are moulded into the desired spring shape using various methods. This process can include various techniques such as wire drawing, bending, coiling and heat treatment. The choice of suitable manufacturing techniques depends on factors such as spring type, application and material. High-precision manufacturing processes are crucial to produce springs with the required mechanical properties. Modern manufacturing technologies help to improve the efficiency and accuracy of spring production.",
  blocks: [

  ],
};
